import React from 'react';
import { Dialog } from 'components/common';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    minWidth: 540,
  },
  content: {
    paddingBottom: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  title: {
    padding: theme.spacing(3),
    width: '90%',
  },
}));

const AlcoholDialog = ({ open, onCancel }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      title="By proceeding you agree to UPS spirits shipping requirements"
      showActionBtns={false}
      classes={{
        root: classes.dialogRoot,
        content: classes.content,
        title: classes.title,
      }}>
      <Typography>
        By selecting to ship alcohol, you confirm that you are legally licensed to ship alcoholic
        beverages and that your UPS account is enrolled in the UPS Alcohol Shipping Program. UPS
        requires all alcohol shipments to:
      </Typography>
      <Box>
        <Typography>
          Be sent only between approved origin and destination states or countries.
        </Typography>
        <Typography>Include Adult Signature Required service.</Typography>
        <Typography>Be properly labeled and packaged according to UPS guidelines.</Typography>
      </Box>
      <Typography>
        Do not proceed unless you meet these requirements. Unauthorized or non-compliant shipments
        may be rejected, delayed, or returned.
      </Typography>
      <Typography>
        For full shipping restrictions and approved states, please see the corresponding article{' '}
        <Link
          href="https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items/spirits"
          target="_blank"
          rel="noopener noreferrer">
          How To Ship Spirits
        </Link>
      </Typography>
    </Dialog>
  );
};

export default AlcoholDialog;
